import React, { useState } from "react";
import { Button, notification, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import upload from "../../utils/upload";
import ImgCrop from "antd-img-crop";
import { useTranslation } from "react-i18next";
import c from "../../utils/common";

const UploadButton = ({ isDisable, buttonLabel, aspect, onFinish }) => {
  const { t, i18n } = useTranslation();

  const [isUploading, setIsUploading] = useState(false);

  const uploadProps = {
    name: "upload",
    accept: "image/png, image/jpeg",
    maxCount: 1,
    showUploadList: false,
    beforeUpload: async (file) => {
      let path = URL.createObjectURL(file);
      console.log(path);

      let fileName;
      try {
        setIsUploading(true);
        // Replace this with your actual upload logic
        fileName = await upload(path); // Simulate upload and get file name
        onFinish(fileName);
      } catch (error) {
        console.error(error);
        let message = error.message == "File size exceeds limit" ? "File size exceeds limit" : "Upload Fail";
        notification.warning({ message: message });
      } finally {
        setIsUploading(false);
      }

      return false;
    },
  };

  const uploadComponent = (
    <Upload {...uploadProps} disabled={isDisable || isUploading}>
      <Button loading={isUploading} type="primary" icon={<UploadOutlined />}>
        {buttonLabel}
      </Button>
    </Upload>
  );

  return (
    <>
      {aspect ? (
        <ImgCrop showGrid rotationSlider aspect={aspect} quality={1}>
          {uploadComponent}
        </ImgCrop>
      ) : (
        uploadComponent
      )}
    </>
  );
};

export default UploadButton;